module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_",
    attrs: {
      "id": "id_Hlk61959347"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('h1', {
    staticClass: "block_1",
    attrs: {
      "id": "toc_id_1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Elle Laga’aia was born to US Navy Samoan parents. She grew up between California and American Samoa. Elle lives in Southern California and is the mother of three daughters and a Siamese cat. In her waking hours, she supports and advocates for animal charities.")]), _vm._v(" "), _c('p', {
    staticClass: "block_3"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_2"
  }, [_vm._v("Elle enjoys traveling to circumnavigate the world, one country at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "block_4",
    attrs: {
      "id": "calibre_pb_0"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c112f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_000.vue
// module id = 63
// module chunks = 0